module.exports = __webpack_public_path__ + "static/media/PortraitBrand.4f7aa3b2.jpeg";